// extracted by mini-css-extract-plugin
module.exports = {"description":"productCardStyle_description__1nexX"};